import { Component, Input } from '@angular/core';
import { ArticleCardVariants } from '../types';
import type { CardProperties } from '../types';

@Component({
    selector: 'fcp-article-card',
    templateUrl: './fcp-article-card.component.html',
    styleUrls: ['./fcp-article-card.component.less', '../fcp-card.component.less'],
    standalone: false
})
export class FcpArticleCardComponent {
    @Input() properties: CardProperties;

    getCardVariant(variantName: keyof typeof ArticleCardVariants): string {
        return ArticleCardVariants[variantName];
    }
}
